import sdl from '@jds/react-generated-sdl/JDSCarousel';
import type { JDSCarouselProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, CarouselProps, type CarouselRef } from '../logic';

const Component = (props: CarouselProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    density = 'undefined',
    indicatorType = 'dot',
    showArrows = false,
    hideLeftArrow = false,
    hideNextSlide = false,
    autoPlay = false,
    showPlayPause = true,
    playing = false,
    showDurationProgress = false,
    PlayPauseAriaLabel = 'Pause or Play Auto slide rotation',
    backButtonAriaLabel = 'Previous Slide',
    nextButtonAriaLabel = 'Next Slide',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      density,
      indicatorType,
      showArrows,
      hideLeftArrow,
      hideNextSlide,
      autoPlay,
      showPlayPause,
      playing,
      showDurationProgress,
      PlayPauseAriaLabel,
      backButtonAriaLabel,
      nextButtonAriaLabel,
      ...rest
    },
    'JDSCarousel',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Carousel = withLogic(Component) as React.ForwardRefExoticComponent<
  CarouselProps & React.RefAttributes<CarouselRef>
> & { slotName?: string };

Carousel.displayName = 'Carousel';
Carousel.slotName = 'jds_carousel';

export { Carousel, type JDSCarouselProps };
